import axios from 'axios';
import { CurrentState, StreamingState } from '../models/StreamingState';
import { EventData } from '../models/EventData';
import { CreateEventRequestDto } from '../models/dto/CreateEventRequestDto';
import { Ticket } from '../models/Ticket';
import { CreateEventResponseDto } from '../models/dto/CreateEventResponseDto';

export const getCurrentEvent = async (uuid: string): Promise<EventData> => {
    const { data } = await axios.get(`/events/${uuid}`);

    return data.data;
};

export const startStreaming = async (uuid: string): Promise<StreamingState> => {
    const { data } = await axios.post(`/events/streaming/start_streaming`, {
        platform: 'web',
        event_uuid: uuid,
    });

    return data.data;
};

export const joinStreaming = async (uuid: string): Promise<StreamingState> => {
    const { data } = await axios.post(`/events/streaming/join_streaming`, {
        platform: 'web',
        event_uuid: uuid,
    });

    return data.data;
};

export const getStreamingState = async (uuid: string): Promise<StreamingState> => {
    const { data } = await axios.get(`/events/streaming/streaming_state/${uuid}`);

    return data.data;
};

export const toggleOpenMic = async (enabled: boolean, uuid: string): Promise<unknown> => {
    const { data } = await axios.post(`/events/streaming/toggle_open_mic`, {
        event_uuid: uuid,
        enabled,
    });

    return data.data;
};

export const toggleChat = async (enabled: boolean, uuid: string): Promise<unknown> => {
    const { data } = await axios.post(`/events/streaming/toggle_chat_enabled`, {
        event_uuid: uuid,
        enabled,
    });

    return data.data;
};

export const toggleRaiseHandViewer = async (uuid: string): Promise<StreamingState> => {
    const { data } = await axios.post(`/events/streaming/raise_hand`, {
        event_uuid: uuid,
    });

    return data.data;
};

export const toggleRaiseHand = async (enabled: boolean, uuid: string): Promise<unknown> => {
    const { data } = await axios.post(`/events/streaming/toggle_raise_hand`, {
        event_uuid: uuid,
        enabled,
    });

    return data.data;
};

export const allowTurn = async (username: string, uuid: string): Promise<CurrentState> => {
    const { data } = await axios.post(`/events/streaming/allow_mic`, {
        event_uuid: uuid,
        username,
    });

    return data.data;
};

export const sendMessage = async (message: string, uuid: string): Promise<null> => {
    const { data } = await axios.post(`/events/streaming/messages_new`, {
        event_uuid: uuid,
        message,
    });

    return data.data;
};

export const toggleBlockUser = async (username: string, uuid: string): Promise<unknown> => {
    const { data } = await axios.post(`/events/streaming/toggle_banned`, {
        event_uuid: uuid,
        username,
    });

    return data.data;
};

export const toggleAdminUser = async (username: string, uuid: string): Promise<unknown> => {
    const { data } = await axios.post(`/events/streaming/toggle_admin`, {
        event_uuid: uuid,
        username,
    });

    return data.data;
};

export const finishEvent = async (uuid: string): Promise<unknown> => {
    const { data } = await axios.post(`/events/streaming/stop_streaming`, {
        event_uuid: uuid,
    });

    return data.data;
};

export const purchaseEvent = async (purchaseData: any): Promise<unknown> => {
    const { data } = await axios.post(`/events/purchase`, purchaseData);

    return data.data;
};

export const purchaseEventWithoutLogin = async (paymentData: any): Promise<unknown> => {
    const { data } = await axios.post(`/events/purchase_no_login`, paymentData);

    return data.data;
};

export const updatePresentationVideo = async (values: unknown): Promise<unknown> => {
    const { data } = await axios.post(`/events/updatePresentationVideo`, values);

    return data.data;
};

export const updatePresentationVideoLandscape = async (values: unknown): Promise<unknown> => {
    const { data } = await axios.post(`/events/updatePresentationVideoLandscape`, values);

    return data.data;
};

export const updateThanksVideo = async (values: unknown): Promise<unknown> => {
    const { data } = await axios.post(`/events/updateThanksVideo`, values);

    return data.data;
};

export const updateThanksVideoLandscape = async (values: unknown): Promise<unknown> => {
    const { data } = await axios.post(`/events/updateThanksVideoLandscape`, values);

    return data.data;
};

export const getTicketTypes = async (): Promise<Ticket[]> => {
    const { data } = await axios.get(`/tickets/types`);

    return data.data;
};

export const createEvent = async (values: CreateEventRequestDto): Promise<CreateEventResponseDto> => {
    const formData = new FormData();
    Object.keys(values).forEach(key => {
        if (['event_rally_nfts_collections', 'event_rally_coins'].includes(key)) {
            // @ts-ignore
            formData.append(key, JSON.stringify(values[key]));
        } else {
            // @ts-ignore
            formData.append(key, values[key]);
        }
    });

    const { data } = await axios.post(`/events/create`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data.data;
};
